import nextDynamic from 'next/dynamic';

// The content component now reads :id via useParams — see prop-boost-content.tsx.
const Content = nextDynamic(() => import('./prop-boost-content'), { ssr: false });

export default function Page() {
  return <Content />;
}
